/* tslint:disable */
/* eslint-disable */
/**
 * Location check service API
 * Service to centralise business area handling for multiple depending services.
 *
*/

import { exists, mapValues } from '../runtime';
import type { AirportZoneRto } from './AirportZoneRto';
import {
    AirportZoneRtoFromJSON,
    AirportZoneRtoFromJSONTyped,
    AirportZoneRtoToJSON,
} from './AirportZoneRto';

/**
 * 
 * @export
 * @interface AirportZoneListRto
 */
export interface AirportZoneListRto {
    /**
     * 
     * @type {Array<AirportZoneRto>}
     * @memberof AirportZoneListRto
     */
    airportZoneList?: Array<AirportZoneRto>;
}

/**
 * Check if a given object implements the AirportZoneListRto interface.
 */
export function instanceOfAirportZoneListRto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AirportZoneListRtoFromJSON(json: any): AirportZoneListRto {
    return AirportZoneListRtoFromJSONTyped(json, false);
}

export function AirportZoneListRtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AirportZoneListRto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'airportZoneList': !exists(json, 'airportZoneList') ? undefined : ((json['airportZoneList'] as Array<any>).map(AirportZoneRtoFromJSON)),
    };
}

export function AirportZoneListRtoToJSON(value?: AirportZoneListRto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'airportZoneList': value.airportZoneList === undefined ? undefined : ((value.airportZoneList as Array<any>).map(AirportZoneRtoToJSON)),
    };
}

